export const selectedProfile = (state) =>
    state?.profile?.profile

export const downloadingProfile = (state) =>
    state?.profile?.downloadingProfile

export const supporters = (state) =>
    state?.profile?.supporters

export const portfolios = (state) =>
  state?.profile?.portfolios